export type PasswordRequirement = {
  id: string;
  label: string;
  test: (password: string) => boolean;
};

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: "length",
    label: "Almeno 10 caratteri",
    test: (p) => p.length >= 10,
  },
  {
    id: "upper",
    label: "Almeno una lettera maiuscola",
    test: (p) => /[A-Z]/.test(p),
  },
  {
    id: "lower",
    label: "Almeno una lettera minuscola",
    test: (p) => /[a-z]/.test(p),
  },
  {
    id: "number",
    label: "Almeno un numero",
    test: (p) => /[0-9]/.test(p),
  },
  {
    id: "special",
    label: "Almeno un carattere speciale",
    test: (p) => /[^A-Za-z0-9]/.test(p),
  },
];

export function validatePassword(password: string): {
  valid: boolean;
  missing: PasswordRequirement[];
} {
  const missing = PASSWORD_REQUIREMENTS.filter((r) => !r.test(password));
  return { valid: missing.length === 0, missing };
}

export function describeMissingRequirements(password: string): string {
  const { missing } = validatePassword(password);
  if (missing.length === 0) return "";
  return `Password non valida: ${missing.map((m) => m.label.toLowerCase()).join(", ")}`;
}
